import { Query } from '@tanstack/react-query';

import { ENTERPRISE_USERS_QUERY_KEY } from 'hooks/queries/enterprise/useEnterpriseMembersInfiniteQuery';
import { ENTERPRISE_ORGANIZATION_CHILD_USER_GROUPS_QUERY_KEY } from 'hooks/queries/enterprise/useUserGroupsInfiniteQuery';
import { ORGANIZATION_USERS_QUERY_KEY } from 'hooks/queries/organization/useOrganizationMembersQuery';
import {
  RBAC_ORGANIZATION_USER_GROUPS_QUERY_KEY,
  RBAC_RESOURCES_QUERY_KEY,
} from 'hooks/queries/rbac';
import { SERVICE_ACCOUNTS_QUERY_KEY } from 'hooks/queries/service-accounts/useGetServiceAccounts';

import {
  RBAC_ROLE_BINDINGS_QUERY_KEY,
  RBAC_ENTERPRISE_ROLE_BINDINGS_QUERY_KEY,
} from '@cast/shared-rbac-data-access';
import { ENTERPRISE_SERVICE_ACCOUNTS_QUERY_KEY } from 'hooks/queries/enterprise/useEnterpriseServiceAccountsQuery';
import { ENTERPRISE_GROUPS_QUERY_KEY } from 'hooks/queries/enterprise/useEnterpriseGroupsQuery';

export const invalidateRbacQueriesPredicate = (query: Query): boolean =>
  [
    RBAC_RESOURCES_QUERY_KEY,
    RBAC_ROLE_BINDINGS_QUERY_KEY,
    RBAC_ENTERPRISE_ROLE_BINDINGS_QUERY_KEY,
    RBAC_ORGANIZATION_USER_GROUPS_QUERY_KEY,
    SERVICE_ACCOUNTS_QUERY_KEY,
    ENTERPRISE_SERVICE_ACCOUNTS_QUERY_KEY,
    ORGANIZATION_USERS_QUERY_KEY, // TODO(adomas): why we need to invalidate users?
    ENTERPRISE_ORGANIZATION_CHILD_USER_GROUPS_QUERY_KEY,
    ENTERPRISE_USERS_QUERY_KEY,
    ENTERPRISE_GROUPS_QUERY_KEY,
  ].includes(query.queryKey[0] as string);
